import { Button, Typography } from '@mui/material'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  handleAccessLocation: () => void
}

export const AccessErrorText = ({ handleAccessLocation }: IProps) => {
  return (
    <div>
      <Typography>
        <HelperWrapper t="scan-form-location-access" />
      </Typography>
      <Button variant="text" onClick={handleAccessLocation}>
        <HelperWrapper t="allow-button-text" />
      </Button>
    </div>
  )
}
